export default function FileIcon(props) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="2" y="2" width="32" height="32" rx="16" fill="#F4EBFF" />
      <path
        d="M18.6667 11.3333H14.0001C13.6465 11.3333 13.3073 11.4737 13.0573 11.7238C12.8072 11.9738 12.6667 12.313 12.6667 12.6666V23.3333C12.6667 23.6869 12.8072 24.026 13.0573 24.2761C13.3073 24.5261 13.6465 24.6666 14.0001 24.6666H22.0001C22.3537 24.6666 22.6928 24.5261 22.9429 24.2761C23.1929 24.026 23.3334 23.6869 23.3334 23.3333V15.9999M18.6667 11.3333L23.3334 15.9999M18.6667 11.3333V15.9999H23.3334"
        stroke="#7F56D9"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2"
        y="2"
        width="32"
        height="32"
        rx="16"
        stroke="#F9F5FF"
        strokeWidth="4"
      />
    </svg>
  );
}
